import { MechanicValidatorLongestRoad } from '@colonist/game-mechanic-validators';
import { useMemo } from 'react';
import { useGameStore } from '../GameStoreContext.ts';
import { useMapValidator } from './useMapValidator.ts';
import { usePlayerValidators } from './usePlayerValidators.ts';
export const useMechanicValidatorLongestRoad = ()=>{
    const { playerValidators } = usePlayerValidators();
    const mapValidator = useMapValidator();
    const mechanicLongestRoadState = useGameStore((state)=>state.gameState.mechanicLongestRoadState);
    return useMemo(()=>{
        if (!mechanicLongestRoadState) return undefined;
        return new MechanicValidatorLongestRoad(playerValidators, mapValidator, mechanicLongestRoadState);
    }, [
        playerValidators,
        mapValidator,
        mechanicLongestRoadState
    ]);
};
